import "./modelist.css";

interface Mode {
    name: string;
    description: string;
}

const MODES: Mode[] = [
    {
        name: "Slenderman",
        description:
            "One player is chosen to be Slenderman. His goal is to kill all the crewmates. Crewmates must avoid him and complete their tasks. As he gets closer to a player, the player’s vision will shrink. When Slenderman gets too close, he will lunge and kill the player. If it starts getting dark, run!",
    },
    {
        name: "Zombies",
        description:
            "One player is chosen to become a zombie. Zombies can infect survivors by touching them, and win if they infect everyone. As a survivor, your goal is to survive and finish all your tasks.",
    },
    {
        name: "Cops & Robbers",
        description:
            "Cops must catch robbers before they can finish their tasks! Robbers need to help each other avoid the cops, free their captured teammates, and complete tasks. To free a captured robber, run into a jail and touch them!",
    },
    {
        name: "Hot Potato",
        description:
            "One person is selected to become the Potato, run away before they tag you!",
    },
    {
        name: "Jester",
        description:
            "One person is selected to become a Jester, they win if they get themselves voted out!",
    },
    {
        name: "Troll",
        description:
            "One person is selected to become a Troll, they win if they get themselves killed by an imposter!",
    },
    {
        name: "Detective",
        description:
            "One player is the secret detective and they will know who murdered who in each meeting! Careful though, as someone might lie about being the detective to try and fool you.",
    },
    {
        name: "50-50",
        description: "The lobby is split into two sets of clones.",
    },
    {
        name: "CrazyColors",
        description: "Every 15 seconds, everyone's color changes!",
    },
    {
        name: "Venteleporter",
        description:
            "When you walk over a vent, you get teleported to a random vent on the map!",
    },
    {
        name: "Twins",
        description: "Everyone in the lobby has a twin, can they be trusted?",
    },
    {
        name: "Clones",
        description:
            "Everyone has the same color, clothing, name, and pet. Who is who?",
    },
    {
        name: "Escalation",
        description:
            "Everyone's walk speed increases by 30% every time somebody gets killed. Run around the map and try to catch the impostor in the act!",
    },
    {
        name: "Standard",
        description: "Vanilla Among Us game. Nothing special!",
    },
];

export default function ModeList() {
    return (
        <div>
            <h2 className="section-heading">What mods can I play?</h2>
            <div className="mode-grid">
                {MODES.map((mode) => (
                    <div className="panel mode-card" key={mode.name}>
                        <h3 className="mode-name">{mode.name}</h3>
                        <p className="mode-description mb-0">
                            {mode.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
